import React from "react";
import { classNames } from "Utils/utils";

const PaSkeleton = ({ variant = "text", className, lines = 3 }) => {
  if (variant === "card") {
    return (
      <div
        className={classNames(
          "animate-pulse rounded-xl border border-gray-200 bg-white p-5 shadow-sm",
          className
        )}
      >
        <div className="h-4 w-24 rounded bg-gray-200" />
        <div className="mt-4 h-8 w-16 rounded bg-gray-200" />
        <div className="mt-4 h-3 w-full rounded bg-gray-100" />
      </div>
    );
  }

  if (variant === "table") {
    return (
      <div
        className={classNames(
          "animate-pulse overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm",
          className
        )}
      >
        <div className="border-b border-gray-200 bg-gray-50 px-4 py-3">
          <div className="h-4 w-1/3 rounded bg-gray-200" />
        </div>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className="flex items-center gap-4 border-b border-gray-100 px-4 py-4 last:border-b-0"
          >
            <div className="h-4 flex-1 rounded bg-gray-100" />
            <div className="h-4 w-24 rounded bg-gray-100" />
            <div className="h-4 w-16 rounded bg-gray-100" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={classNames("animate-pulse space-y-2", className)}>
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            "h-4 rounded bg-gray-200",
            index === lines - 1 ? "w-2/3" : "w-full"
          )}
        />
      ))}
    </div>
  );
};

export default PaSkeleton;
